import React from 'react';
import _ from 'lodash';
import { ActionButton } from '@ax2/common/components/ActionButton';
import styles from '@/styles/components/question-builders/QuestionOverlay.module.css';

export interface QuestionOverlayIconAction {
  source?: string;
}

export interface QuestionOverlayAction {
  text: string;
  icon?: QuestionOverlayIconAction;
  onClick: () => void;
}

export interface QuestionOverlayData {
  primaryActions: QuestionOverlayAction[];
  secondaryActions: QuestionOverlayAction[];
  helperText?: string;
}

export const QuestionOverlay: React.FC<QuestionOverlayData> = props => {
  return (
    <div className={styles.questionActionOverlay}>
      <div className={styles.questionActionsContainer}>
        {_.map(props.primaryActions, (pa, i) => (
          <ActionButton {...pa} type="secondaryAlt" key={i}></ActionButton>
        ))}
        {_.map(props.secondaryActions, (sa, i) => (
          <ActionButton {...sa} type="primary" key={i}></ActionButton>
        ))}
      </div>
      <div className={styles.infoText}>
        <span>{props.helperText}</span>
      </div>
    </div>
  );
};
